import { Location } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AuditItemModel } from 'src/app/audit-items/audit-item.model';
import { AuditsViewItemsComponent } from 'src/app/audits/audits-view/audits-view-items/audits-view-items.component';
import { AuditsModel } from 'src/app/audits/audits.model';
import { AuditsService } from 'src/app/audits/audits.service';
import { RBACService } from 'src/app/shared/rbac.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { UserPublicProfileComponent } from '../../shared/user-public-profile/user-public-profile.component';
import { ApiRequestService } from '../../shared/api-request.service';
import { AssetsService } from '../../assets/assets.service';

@Component({
  selector: 'app-sites-audits-view',
  templateUrl: './sites-audits-view.component.html',
  styleUrls: ['./sites-audits-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SitesAuditsViewComponent implements OnInit {
  audit = new AuditsModel();
  displayedColumns = ['name', 'status', 'actions'];
  displayedContractorColumns = ['name', 'industry', 'address', 'actions'];
  displayedAssetColumns = [
    'name',
    'code',
    'asset_type',
    'status',
    'condition_rating'
  ];
  displayedContactsColumns = ['contact_name', 'email', 'user_status'];
  contactDataSource;
  auditId: number;
  editRoute: string;

  // RBAC permission flags: resolved once in ngOnInit().
  canView: boolean = false;
  canEdit: boolean = false;

  /**
   * A unique list of sections.
   */
  sections: string[] = [];

  /**
   * Audit items grouped by section.
   */
  sectionsItems: { [section: string]: AuditItemModel[] } = {};

  parent_id: number;
  child_id: number;
  site_id: number;

  constructor(
    private api: ApiRequestService,
    private route: ActivatedRoute,
    private auditsService: AuditsService,
    private dialog: MatDialog,
    public utils: UtilsService,
    public location: Location,
    public rbac: RBACService,
    public assetsService: AssetsService
  ) {}

  ngOnInit() {
    // 1. Check view permission: redirect back if denied.
    this.canView = this.rbac.userCanAccess(
      [
        RBACService.getPermission(
          RBACService.RBAC_F.F_SITES_INSPECTIONS_AUDITS,
          RBACService.RBAC_A.A_VIEW
        )
      ],
      true
    );

    if (!this.canView) {
      this.rbac.showGenericAccessDeniedMessage(
        'You do not have permission to view inspections & audits.'
      );
      this.location.back();
      return;
    }

    // 2. Resolve canEdit flag for Edit button visibility.
    this.canEdit = this.rbac.userCanAccess(
      [
        RBACService.getPermission(
          RBACService.RBAC_F.F_SITES_INSPECTIONS_AUDITS,
          RBACService.RBAC_A.A_EDIT
        )
      ],
      true
    );

    // Get the site id from the route params.
    this.parent_id = Number(this.route.parent.snapshot.params['parent_id']);
    this.child_id = Number(this.route.parent.snapshot.params['child_id']);

    // Check if we are updating a site or creating a new one.
    if (
      this.child_id ||
      (typeof this.route.parent.snapshot.params['child_id'] == 'undefined' &&
        this.parent_id)
    ) {
      // Store the site id.
      this.site_id = this.child_id ? this.child_id : this.parent_id;

      this.auditId = Number(this.route.snapshot.params['audit_id']);
      if (this.auditId) {
        this.auditsService.find(this.auditId).subscribe((response) => {
          this.audit = response.data;

          this.audit.items.forEach((item) => {
            if (this.sections.indexOf(item.section) === -1) {
              this.sections.push(item.section);
            }

            if (!this.sectionsItems[item.section]) {
              this.sectionsItems[item.section] = [];
            }

            this.sectionsItems[item.section].push(item);
          });
        });
      }
    }

    this.getAuditContactsApi();
  }

  getAuditContactsApi(page?) {
    this.auditsService.getContacts(this.auditId, page).subscribe((res) => {
      this.contactDataSource = res.data;
    });
  }

  handlePageEvent(e) {
    this.getAuditContactsApi(e.pageIndex + 1);
  }

  onOpenUrl(url: string) {
    this.utils.openUrl(url);
  }

  downloadPdf() {
    this.api
      .makeRequest(
        'get',
        'v2/site-audits/export/pdf',
        {},
        {
          site_ids: this.site_id,
          selected_ids: this.audit.id
        }
      )
      .then((response) => {
        // Check if we have a message response.
        if (typeof response.message != 'undefined') {
          this.utils.showToast(response.message);
        }
      })
      .catch((errorResponse) => {
        this.utils.handleAPIErrors(errorResponse);
      });
  }

  view(item: AuditItemModel) {
    this.utils.showComponentDialog(AuditsViewItemsComponent, item, {
      width: '700px'
    });
  }

  onUserPublicView(hash: string) {
    this.utils.showComponentDialog(
      UserPublicProfileComponent,
      hash,
      { width: '90%' },
      () => {
        // Refresh the list regardless of how the dialog is closed.
      }
    );
  }
}
